import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import * as React from 'react'

export const GuideCardSkeleton = React.memo(function GuideCardSkeleton() {
  return (
    <Card
      className="overflow-hidden rounded-lg border border-border bg-card shadow-sm"
      aria-busy="true"
      aria-label="Loading guide card"
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 rounded-lg px-6 pb-0 pt-6">
        <Skeleton className="h-5 w-20 rounded-full" />
        <Skeleton className="h-14 w-14 rounded-md" />
      </CardHeader>

      <CardContent className="px-6 pb-0 pt-0">
        <div className="mt-5 space-y-3">
          <Skeleton className="h-7 w-32" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        </div>
      </CardContent>

      <CardFooter className="flex justify-end rounded-lg px-5 pb-3.5 pt-1">
        <Skeleton className="mt-2 h-9 w-32" />
      </CardFooter>
    </Card>
  )
})

GuideCardSkeleton.displayName = 'GuideCardSkeleton'
